export default function formatSortCode(input?: string) {
    if (input === undefined || input === "") {
        return "";
    }
    if (input.length <= 2) return input;
    if (input.length <= 4) return `${input.slice(0, 2)}-${input.slice(2)}`;
    return `${input.slice(0, 2)}-${input.slice(2, 4)}-${input.slice(4)}`;
}
